import React, { Component } from 'react';
import './index.css';
import Cursor from './Cursor';
import Navbar from './Component/NavBar';

export default class App extends Component {
  render() {

    return (
      <div className="App">
        <Cursor />
        <div className="row">
          <Navbar />
          <div className="column-right">
            <div className="wrapper">
              <div className="col1-start col-1end">
                <p><b>Ploypilin (Ploy) Pruekcharoen</b> (she/her) is a researcher who is passionate about
                  <b> responsible AI and emerging technology</b>. Her works focus on the integration of <b>art and technology</b>.
                  She is currently pursuing a Master's degree in Integrated Design &amp; Media at 
                  New York University.
                  Growing up in a remote area in Thailand, she is also interested in <b>social values and cultural diversity</b>. 
                  Her personal background majorly drives her to work on creative projects and research related to humans and 
                  society.
                </p>
                <p><a href="https://drive.google.com/file/d/1zCdLafqwgvi0q4gdTa5PYbep5uwHcZMs/view?usp=sharing" target="_blank" rel="noreferrer">See Ploy's resume &rarr;</a></p>
                <img className="paddingtop30 portrait" src="img/me.gif" alt="My Portrait"/>
                <div>
                  <p className="paddingtop30">check out Ploy's <a href="https://open.spotify.com/playlist/1VRyoaF9WgAZnEoUgE2Bgl?si=4f0oB-2kQqWJh4D7_qvZ3Q" target="_blank" rel="noreferrer">spotify playlist</a>
                  <b> / now reading: </b> AI Narratives <i>by Stephen Cave, Kanta Dihal, Sarah Dillon</i>; Crying in H Mart <i>by Michelle Zauner</i></p>
                </div>
              </div>
            </div>
            
            
          </div>
        </div>
      </div>
    );
  }
}
